// eslint-disable-next-line
// import { useDispatch } from 'react-redux';
import {
  // readChannelNotifications,
  readNotifications,
} from '../service/chatAPIHandler';
import { getUserTimeZoneDateFormat } from './dateHelper';
import {
  getNotificationsForBooking,
  getNotificationsForOrder,
  getNotificationsForShipment,
} from './notificationHelper';
import { getUser } from '../service/authService';
// import { readNotification } from '../redux/actions';

const getInitials = (str) => {
  let name = str
    ?.split(' ')
    ?.map((word) => word[0])
    ?.join('');
  name = name?.substr(0, 2);
  return name?.toUpperCase();
};

export const metaDataObjectManipulation = (object, item) => {
  let description = object;
  if (item?.type) {
    switch (item?.type) {
      case 'object': {
        const splitKey = item?.accessor.split('.');
        splitKey?.forEach((key) => {
          description = description?.[key] || '--';
        });
        break;
      }
      case 'date': {
        description = getUserTimeZoneDateFormat(description[item.accessor]);
        break;
      }
      default: {
        description = description[item.accessor];
        break;
      }
    }
  } else {
    description = description[item.accessor];
  }

  return description;
};

export default getInitials;

export const getSingleInitials = (str) => {
  let name = str
    .split(' ')
    .map((word) => word[0])
    .join('');
  name = name.substr(0, 1);
  return name.toUpperCase();
};

export const readNotifData = async (data, type) => {
  const checkNotifications = [];
  await data?.forEach(async (id) => {
    let notifications;
    switch (type) {
      case 'order':
        notifications = getNotificationsForOrder(id).map((item) => item._id);
        break;
      case 'booking':
        notifications = getNotificationsForBooking(id).map((item) => item._id);
        break;
      case 'shipment':
        notifications = getNotificationsForShipment(id).map((item) => item._id);
        break;
      default:
        break;
    }

    async function markNotificationRead() {
      if (notifications.length !== 0) {
        await readNotifications(notifications);
        return notifications;
      }
      return 0;
    }

    const readNotific = await markNotificationRead();
    if (readNotific) {
      checkNotifications.push(...readNotific);
    }
  });
  return checkNotifications;
};

export const favIconUpdate = (favIcon, title) => {
  const unaccepted = [null, undefined, ''];
  const favIconEle = document.getElementById('favicon');
  const appleFavIconEle = document.getElementById('apple-favicon');
  const favTitle = document.getElementById('title-ico');
  if (!unaccepted.includes(favIcon)) {
    favIconEle.href = favIcon;
    appleFavIconEle.href = favIcon;
  }
  if (!unaccepted.includes(title)) {
    favTitle.innerHTML = title;
  }
};

export const getNumber = (e) => {
  let key;
  if (e.type === 'paste') {
    key = e.clipboardData.getData('text/plain');
  } else {
    key = e.keyCode || e.which;
    key = String.fromCharCode(key);
  }
  if ([8, 32, 37, 39, 91, 189, 187, 65].includes(e.keyCode)) {
    return;
  }
  const regex = /[0-9+-/ ]|\./;
  if (!regex.test(key)) {
    e.returnValue = false;
    if (e.preventDefault) e.preventDefault();
  }
};

// export const getNumberWithDot = ({ e, decimalLimit }) => {
//   const key =
//     e.type === 'paste' ? e.clipboardData.getData('text/plain') : e.key;

//   const allowedKeys = [
//     'Backspace',
//     'ArrowLeft',
//     'ArrowRight',
//     'Control',
//     'Meta',
//     'Delete',
//     '.',
//     'Tab',
//   ];

//   // Allow navigation, deletion, and special keys
//   if (e.type !== 'paste' && allowedKeys.includes(key)) {
//     // Prevent multiple dots
//     if (key === '.' && e.target.value.includes('.')) {
//       e.preventDefault();
//       return;
//     }
//     return;
//   }

//   // Allow copy, paste, cut, and select-all shortcuts
//   if (
//     (e.ctrlKey || e.metaKey) &&
//     ['a', 'c', 'v', 'x'].includes(key.toLowerCase())
//   ) {
//     return;
//   }

//   if (e.type === 'paste') {
//     const pastedValue = key;
//     if (!/^\d*\.?\d*$/.test(pastedValue)) {
//       e.preventDefault(); // Block invalid pasted content
//       return;
//     }

//     // Trim pasted value to fit within the decimal limit
//     const [integerPart, decimalPart] = pastedValue.split('.');
//     if (decimalPart && decimalPart.length > decimalLimit) {
//       e.preventDefault();
//       const trimmedValue = `${integerPart}.${decimalPart.slice(
//         0,
//         decimalLimit
//       )}`;
//       e.target.value = trimmedValue;
//     }
//     return;
//   }

//   // Block invalid characters
//   if (!/^[0-9.]$/.test(key)) {
//     e.preventDefault();
//     return;
//   }

//   const { value, selectionStart } = e.target;
//   const dotIndex = value.indexOf('.');

//   // Prevent multiple dots
//   if (key === '.' && dotIndex !== -1) {
//     e.preventDefault();
//     return;
//   }

//   // Restrict decimal places
//   if (dotIndex !== -1 && selectionStart > dotIndex) {
//     const decimals = value?.split('.')?.[1] || '';
//     if (decimals.length >= decimalLimit) {
//       e.preventDefault();
//       return;
//     }
//   }

//   // Enforce length limit
//   if (value.length >= 50 && key !== 'Backspace') {
//     e.preventDefault();
//     e.target.value = value.slice(0, 50);
//   }
// };

export const getNumberWithDot = ({ e, decimalLimit }) => {
  const key =
    e.type === 'paste' ? e.clipboardData.getData('text/plain') : e.key;

  const allowedNavigationKeys = [
    'Backspace',
    'ArrowLeft',
    'ArrowRight',
    'Delete',
    'Tab',
  ];

  // Allow shortcuts like Ctrl+C, Ctrl+V, Cmd+A etc.
  if (
    (e.ctrlKey || e.metaKey) &&
    ['a', 'c', 'v', 'x'].includes(key.toLowerCase())
  ) {
    return;
  }

  // Allow navigation and delete keys
  if (allowedNavigationKeys.includes(key)) {
    return;
  }

  const { value, selectionStart, selectionEnd } = e.target;

  // Handle paste separately
  if (e.type === 'paste') {
    const pastedValue = key;
    if (!/^\d*\.?\d*$/.test(pastedValue)) {
      e.preventDefault(); // Block invalid pasted content
      return;
    }

    // Trim pasted value to fit within the decimal limit
    const [integerPart, decimalPart] = pastedValue.split('.');
    if (decimalPart && decimalPart.length > decimalLimit) {
      e.preventDefault();
      const trimmedValue = `${integerPart}.${decimalPart.slice(
        0,
        decimalLimit
      )}`;
      e.target.value = trimmedValue;
    }
    return;
  }

  // Simulate what the value would be after this keypress
  const simulatedValue =
    value.slice(0, selectionStart) + key + value.slice(selectionEnd);

  // Check if simulated value is valid number
  if (!/^\d*\.?\d*$/.test(simulatedValue)) {
    e.preventDefault();
    return;
  }

  // Prevent multiple dots
  if (
    (key === '.' && value.includes('.')) ||
    simulatedValue.split('.').length > 2
  ) {
    e.preventDefault();
    return;
  }

  // Check decimal length
  const [, decimalPart] = simulatedValue.split('.');
  if (decimalPart && decimalPart.length > decimalLimit) {
    e.preventDefault();
    return;
  }

  // Limit total length
  if (simulatedValue.length > 50) {
    e.preventDefault();
    // return;
  }
};

export const getDigitsOnly = (e) => {
  if (e.type === 'paste') {
    const pasteContent = e.clipboardData.getData('text/plain');
    // Prevent pasting non-numeric content or exceeding 50 characters
    if (
      !/^\d+$/.test(pasteContent) ||
      pasteContent.length + e.target.value.length > 50
    ) {
      e.preventDefault();
    }
    return;
  }

  const { key } = e;
  const controlKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
  if (controlKeys.includes(key)) {
    return; // Allow control keys
  }

  // Allow copy, paste, cut, and select-all shortcuts
  if (
    (e.ctrlKey || e.metaKey) &&
    ['a', 'c', 'v', 'x'].includes(key.toLowerCase())
  ) {
    return;
  }

  // Prevent further input if the current value length is already 50
  if (e.target.value.length >= 50) {
    e.preventDefault();
    return;
  }

  // Prevent non-numeric key input
  if (!/^\d$/.test(key)) {
    e.preventDefault();
  }
};

export const maxDecimalDigit = (value, digits = 3) => {
  if (value.startsWith('.')) return '';
  const regex = new RegExp(`^\\d*\\.?\\d{0,${digits}}`);
  return value.match(regex)?.[0] || '';
};

export const restrictDecimalOnKeyDown = (e, digits = 3) => {
  const { key, target } = e;
  const { value, selectionStart } = target;

  // Allow control keys
  if (
    key === 'Backspace' ||
    key === 'Delete' ||
    key === 'ArrowLeft' ||
    key === 'ArrowRight' ||
    key === 'Tab'
  ) {
    return;
  }

  if (!/[0-9.]/.test(key)) {
    e.preventDefault();
    return;
  }

  if (key === '.' && value.includes('.')) {
    e.preventDefault();
    return;
  }

  if (value.includes('.')) {
    const decimalPart = value.split('.')[1];
    if (decimalPart.length >= digits && selectionStart > value.indexOf('.')) {
      e.preventDefault();
    }
  }
};

export const normalizeDecimalValue = (value = '', digits = 3) => {
  const strValue = String(value ?? '');

  if (strValue.startsWith('.')) return '';

  const regex = new RegExp(`^\\d*\\.?\\d{0,${digits}}`);
  return strValue.match(regex)?.[0] || '';
};

export function CopyClipborad(text) {
  navigator.clipboard.writeText(text);
}
export const getDigitsForPhoneNumber = (e) => {
  let key;
  if (e.type === 'paste') {
    key = e.clipboardData.getData('text/plain');
  } else {
    key = e.key;
  }
  if (!/[0-9+\b]/.test(key) && e.keyCode !== 8) {
    e.preventDefault();
  }
};
export const getAlphaNumericWithLimit = (e) => {
  if (e.type === 'paste') {
    const pasteContent = e.clipboardData.getData('text/plain');

    // Allow only alphanumeric content and prevent pasting if length exceeds 50 characters
    const sanitizedContent = pasteContent.replace(/[^a-zA-Z0-9]/g, ''); // Remove any non-alphanumeric characters
    const newValue = e.target.value + sanitizedContent;

    if (newValue.length > 50) {
      // Prevent paste if total length would exceed 50 characters
      e.preventDefault();
    } else {
      // Update the input with the sanitized value (truncated to 50 characters)
      e.target.value = newValue.slice(0, 50);
    }

    return;
  }

  const { key } = e;
  const controlKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];

  // Allow control keys like backspace, delete, and arrows
  if (controlKeys.includes(key)) {
    return;
  }

  // Prevent further input if the current value length is already 50
  if (e.target.value.length >= 50) {
    e.preventDefault();
    return;
  }

  // Prevent special characters and allow only alphanumeric input
  if (!/^[a-zA-Z0-9]$/.test(key)) {
    e.preventDefault();
  }
};

export const fetchAddress = (
  direction,
  option,
  listData,
  destDoorAddrs,
  oriDoorAddrs
) => {
  let address = direction === 'destination' ? destDoorAddrs : oriDoorAddrs;
  if (listData?.length > 0) {
    address = listData;
  }
  const resultAddress = address?.filter((item) => {
    return item?.types[0] === option;
  })[0]?.long_name;
  return resultAddress || '';
};

export const convertCamelCaseToTitleCase = (input) => {
  const words = input?.split(/(?=[A-Z])/); // Split at capital letters
  const titleCaseWords = words?.map(
    (word) => word.charAt(0).toUpperCase() + word.slice(1)
  );
  return titleCaseWords?.join(' ');
};

export const phoneRegExp = /^(?!0)(\+\d{1,4}\s?)?(\d{1,4}\s?)?(\d\s?){6,14}\d$/;

export const isNumber = (value) =>
  typeof value === 'number' && !Number.isNaN(value);

export function checkRequestPermission(userData) {
  const currentUser = getUser();
  const result = userData?.some((users) => users?.userSub === currentUser?.sub);
  return result;
}

export const getEnglishMode = (inputMode) => {
  // NOTE: Here the convert of road in turkish is wrong as it is karayolu, but we have mapped karayolu with "Inland" for omni Platfrom
  const modeMap = {
    aéreo: 'Air',
    marítimo: 'Ocean',
    terrestre: 'Inland',
    rodoviário: 'Road',
    havayolu: 'Air',
    denizyolu: 'Ocean',
    karayolu: 'Inland',
    kara: 'Inland',
    karayolue: 'Road',
    air: 'Air',
    ocean: 'Ocean',
    inland: 'Inland',
    road: 'Road',
  };

  const normalizedMode = inputMode?.toLowerCase().trim();
  return modeMap[normalizedMode] || '';
};

export function formatNumberUpTo3Decimals(value) {
  if (value === null || value === undefined || value === '') return '';
  return parseFloat(Number(value).toFixed(3));
}

export function truncateString(str, maxLength) {
  if (str === null || str === undefined || typeof str !== 'string') {
    return '';
  }
  if (str.length > maxLength) {
    return `${str.slice(0, maxLength)}...`;
  }
  return str;
}

const mimeToExtension = {
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
  'application/vnd.ms-excel': 'xls',
  'application/pdf': 'pdf',
  'image/jpeg': 'jpg',
  'image/png': 'png',
  'text/csv': ' csv',
};

export function getExtensionFromMime(mimeType) {
  return mimeToExtension[mimeType] || '';
}
